import React from 'react'
import { format } from 'date-fns'

import LgyField from 'app/components/util/lgy-field/LgyField'
import BasicLgyTextArea from 'app/components/util/lgy-text-area/BasicLgyTextArea'
import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import { formatDollars } from '../common/AssignmentUtils'

const AssignmentDetailsSection = ({ assignmentDetails, handleInvalid, handleChange, invalidMessage, isUploadingDisabled, legalDescription }) =>
  <LgySubsection header='Assignment Details' className='assignment-details-section'>
    <LgyField className='non-input' label=' Date of last update' value={format(assignmentDetails.lastCaseUpdate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true })} />
    {assignmentDetails.refinanceAmount
      ? <LgyField className='non-input' label='Refinance Amount' value={`$${formatDollars(assignmentDetails.refinanceAmount)}`} />
      : <LgyField className='non-input' label='Sale Price' value={`$${formatDollars(assignmentDetails.salePrice)}`} />}
    <fieldset id='legalDescriptionFieldset' disabled={isUploadingDisabled}>
      <legend className='usa-sr-only'>Edit Legal Description</legend>
      <BasicLgyTextArea
        id='legalDescription'
        name='legalDescription'
        label='Legal Description'
        value={legalDescription}
        onChange={handleChange}
        onInvalid={handleInvalid}
        dirty={legalDescription === assignmentDetails.legalText || legalDescription === '' ? 0 : 1}
        error={invalidMessage.find(error => error.startsWith('Legal Description')) ? 'Required' : undefined}
        maxLength='1000'
        required />
    </fieldset>
    <div>(Unsupported special characters will be removed from the Legal Description.)</div>
  </LgySubsection>

export default AssignmentDetailsSection
